// extracted by mini-css-extract-plugin
export default {"container":"q5dNKJ","page":"Y1f6ly"};